/**
 * Expert Search 优化的转换函数
 * 使用统一配置替代原有的硬编码映射
 * 复用现有的 createMetaInfo 方法
 */

import type { IFieldGroup } from '@pharmsnap/pharmsnap-web/composable/useDrugFinderExpertSearch'
import { buildQueryHierarchy, IQueryItemWithMeta, processCombinedGroup, processSimpleGroup } from './queryTransformHelpers'

/**
 * 将 IFieldGroup[] 转换为标准 Query (优化版本)
 * 相比原���改进:
 * 1. 使用统一的 fieldConfig 配置
 * 2. 复用 createMetaInfo 方法
 * 3. 消除重复的映射函数 (getFieldMapping, getFieldType, getSearchStrategy)
 * 4. 更清晰的逻辑结构
 *
 * @param groups - 字段组数组
 * @returns 标准Query结构
 */
export function convertToStandardQueryItemsOptimized(groups: IFieldGroup[]): IQueryItemWithMeta | undefined {
  if (!groups || groups.length === 0) return undefined

  const allQueries: Array<{
    query: IQueryItemWithMeta
    logic: 'AND' | 'OR' | 'NOT'
    originalIndex: number
    originalGroup: IFieldGroup
  }> = []
  groups.forEach((group, index) => {
    if (group.type === 'combined') {
      // 组合字段处理
      const combinedQueries = processCombinedGroup(group)
      if (combinedQueries.length > 0) {
        // 如果只有一个字段，直接使用该字段；如果有多个字段，包装成group
        allQueries.push({
          query:
            combinedQueries.length === 1
              ? combinedQueries[0]
              : {
                  type: 'group',
                  must: combinedQueries,
                },
          logic: index === 0 ? 'AND' : group.logic,
          originalIndex: index,
          originalGroup: group,
        })
      }
    } else {
      // 简单字段处理
      const simpleQueries = processSimpleGroup(group, index)
      allQueries.push(...simpleQueries)
    }
  })
  // 根据逻辑关系构建层级结构
  return buildQueryHierarchy(allQueries)
}
